/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { ReactElement, useState, forwardRef, useRef } from "react";
import classNames from "classnames";
import { useCombinedRefs } from "../../utils/useCombinedRefs";
import { renderIconClassName } from "../../utils";

interface TabHeaderProps {
  title: string;
  icon?: string;
  subheader?: string;
  isActive: boolean;
  tabName: string;
  onClick: (
    event:
      | React.MouseEvent<HTMLLIElement, MouseEvent>
      | React.KeyboardEvent<HTMLLIElement>
  ) => void;
}

export const TabHeader = forwardRef<HTMLLIElement, TabHeaderProps>(
  (
    { title, icon, subheader, isActive, tabName, onClick },
    containerExternalRef
  ): ReactElement => {
    const [isFocused, setIsFocused] = useState(false);
    const containerRef = useRef<HTMLLIElement>(null);

    useCombinedRefs(containerRef, containerExternalRef);

    const handleFocus = (): void => setIsFocused(true);
    const handleBlur = (): void => setIsFocused(false);

    const contentClass = classNames("spark-tabs__tab", {
      active: isActive,
      focus: isFocused,
    });

    return (
      <li
        ref={containerRef}
        className={contentClass}
        role="presentation"
        onBlur={handleBlur}
        onClick={onClick}
        onFocus={handleFocus}
        onKeyDown={(e): void => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onClick(e);
          }
        }}
      >
        {icon && (
          <span className={renderIconClassName(icon)} aria-hidden="true" />
        )}
        <a
          href="#"
          onClick={(e): void => {
            // Prevent a default action of an anchor
            e.preventDefault();
          }}
          id={tabName}
          aria-selected={isActive}
          role="tab"
          aria-controls={`tabpanel-${tabName}`}
        >
          {title}
          {subheader && <br />}
          {subheader && <small>{subheader}</small>}
        </a>
      </li>
    );
  }
);

TabHeader.displayName = "TabHeader";
